import { apiEndpoints } from "@/services/api/api";
import { LoaderFunctionArgs } from "react-router-dom";
import { ManageCourseUpdateSectionLoaderDTO } from "../types/manageCourseLoaderTypes";

export async function ManageCourseUpdateSectionLoader({
  params,
}: LoaderFunctionArgs): Promise<ManageCourseUpdateSectionLoaderDTO> {
  const sectionId = params.sectionId;
  if (!sectionId) {
    throw new Error("sectionId parametresi eksik");
  }
  try {
    const result = await apiEndpoints.lecturerGetSectionContent(sectionId);
    if (!result.success) {
      throw new Error(result.message || "Bölüm içeriği yüklenemedi");
    }
    return result.data;
  } catch (error) {
    console.error("Bölüm içeriği yüklenirken hata oluştu:", error);
    throw new Error("Bölüm içeriği yüklenemedi");
  }
}
